(function(){
  'use strict';
  function init(root){
    var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-rp-tab]'));
    var panels=Array.prototype.slice.call(root.querySelectorAll('[data-rp-panel]'));
    var panelHashes={intake:'#repair-intake',status:'#repair-status-preview',process:'#repair-how-it-works'};
    var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function showPanel(name){
      tabs.forEach(function(tab){var active=tab.getAttribute('data-rp-tab')===name;tab.setAttribute('aria-selected',String(active));tab.setAttribute('tabindex',active?'0':'-1');});
      panels.forEach(function(panel){var active=panel.getAttribute('data-rp-panel')===name;panel.hidden=!active;panel.classList.toggle('is-active',active);});
    }
    function scrollToPanel(name,behavior){
      var selector=panelHashes[name];
      var target=selector?root.querySelector(selector):null;
      if(target&&typeof target.scrollIntoView==='function'){target.scrollIntoView({behavior:reduceMotion?'auto':behavior,block:'start'});}
    }
    function openPanelFromHash(behavior){
      return Object.keys(panelHashes).some(function(name){
        if(window.location.hash===panelHashes[name]){showPanel(name);window.requestAnimationFrame(function(){scrollToPanel(name,behavior);});return true;}
        return false;
      });
    }
    tabs.forEach(function(tab){tab.addEventListener('click',function(){var name=tab.getAttribute('data-rp-tab');showPanel(name);var workspace=root.querySelector('.uc-rp__workspace');if(workspace&&window.scrollY>workspace.offsetTop){workspace.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});}});});
    root.querySelectorAll('[data-rp-open]').forEach(function(link){link.addEventListener('click',function(event){event.preventDefault();var name=link.getAttribute('data-rp-open');showPanel(name);var hash=panelHashes[name];if(hash&&window.location.hash!==hash){window.history.pushState(null,'',hash);}window.requestAnimationFrame(function(){scrollToPanel(name,'smooth');});});});
    openPanelFromHash('auto');
    window.addEventListener('hashchange',function(){openPanelFromHash('smooth');});
    window.addEventListener('popstate',function(){openPanelFromHash('smooth');});

    var form=root.querySelector('#uc-repair-intake');
    if(form){
      var steps=Array.prototype.slice.call(form.querySelectorAll('[data-rp-step]'));
      var dots=Array.prototype.slice.call(root.querySelectorAll('[data-rp-step-dot]'));
      var next=form.querySelector('[data-rp-next]');
      var back=form.querySelector('[data-rp-back]');
      var submit=form.querySelector('[data-rp-submit]');
      var current=0;
      function fieldsForStep(){return Array.prototype.slice.call(steps[current].querySelectorAll('input,select,textarea')).filter(function(field){return !field.disabled&&field.type!=='hidden';});}
      function validStep(){
        var fields=fieldsForStep();
        for(var i=0;i<fields.length;i++){if(!fields[i].checkValidity()){fields[i].reportValidity();return false;}}
        return true;
      }
      function update(){
        steps.forEach(function(step,index){var active=index===current;step.hidden=!active;step.classList.toggle('is-active',active);});
        dots.forEach(function(dot,index){dot.classList.toggle('is-current',index===current);dot.classList.toggle('is-done',index<current);});
        back.hidden=current===0;next.hidden=current===steps.length-1;submit.hidden=current!==steps.length-1;
      }
      function value(name){var field=form.querySelector('[name="'+name+'"]');return field?field.value.trim():'';}
      function checkedValue(name){var field=form.querySelector('[name="'+name+'"]:checked');return field?field.value:'';}
      function checkedItems(){return Array.prototype.slice.call(form.querySelectorAll('input[name^="contact[item_"]:checked')).map(function(field){return field.value;}).join(', ')||'None listed';}
      function escapeHtml(text){var div=document.createElement('div');div.textContent=text||'Not provided';return div.innerHTML;}
      function fillReview(){
        var review=form.querySelector('[data-rp-review]');if(!review)return;
        review.innerHTML='<div><small>CUSTOMER</small><b>'+escapeHtml(value('contact[name]'))+'</b><span>'+escapeHtml(value('contact[organization]'))+' · '+escapeHtml(value('contact[email]'))+'</span></div>'+
          '<div><small>AIRCRAFT</small><b>'+escapeHtml(value('contact[manufacturer]')+' '+value('contact[aircraft_model]'))+'</b><span>SN '+escapeHtml(value('contact[serial_number]'))+' · '+escapeHtml(checkedItems())+'</span></div>'+
          '<div><small>ISSUE</small><b>'+escapeHtml(value('contact[service_reason]'))+'</b><span>'+escapeHtml(checkedValue('contact[current_condition]'))+'</span></div>'+
          '<div><small>ARRIVAL</small><b>'+escapeHtml(checkedValue('contact[arrival_method]'))+'</b><span>Instructions provided after review</span></div>';
      }
      function buildBody(reference){
        return [
          'UNMANNED CANADA REPAIR INTAKE',
          'Reference: '+reference,
          '',
          'CUSTOMER',
          'Name: '+value('contact[name]'),
          'Organization: '+value('contact[organization]'),
          'Email: '+value('contact[email]'),
          'Phone: '+value('contact[phone]'),
          'Preferred update: '+checkedValue('contact[update_method]'),
          '',
          'AIRCRAFT',
          'Manufacturer: '+value('contact[manufacturer]'),
          'Model: '+value('contact[aircraft_model]'),
          'Serial number: '+value('contact[serial_number]'),
          'Purchase source: '+value('contact[purchase_source]'),
          'Items expected: '+checkedItems(),
          '',
          'ISSUE',
          'Reason: '+value('contact[service_reason]'),
          'Condition: '+checkedValue('contact[current_condition]'),
          'Details: '+value('contact[issue_details]'),
          '',
          'LOGISTICS',
          'Arrival method: '+checkedValue('contact[arrival_method]'),
          '',
          'AUTHORIZATION',
          'Inspection consent only. No paid parts or repair work authorized.'
        ].join('\n');
      }
      next&&next.addEventListener('click',function(){if(!validStep())return;if(current<steps.length-1){current++;if(current===steps.length-1)fillReview();update();}});
      back&&back.addEventListener('click',function(){if(current>0){current--;update();}});
      form.addEventListener('submit',function(event){if(!validStep()){event.preventDefault();return;}var now=new Date();var stamp=String(now.getFullYear()).slice(-2)+String(now.getMonth()+1).padStart(2,'0')+String(now.getDate()).padStart(2,'0');var reference='UC-RPR-'+stamp+'-'+Math.random().toString(36).slice(2,6).toUpperCase();var ref=form.querySelector('[data-rp-reference]');var body=form.querySelector('[data-rp-body]');if(ref)ref.value=reference;if(body)body.value=buildBody(reference);});
      update();
    }

    var decisionButtons=Array.prototype.slice.call(root.querySelectorAll('[data-rp-decision]'));
    var decisionPreview=root.querySelector('[data-rp-decision-preview]');
    var decisionMessages={decline:'Preview selected: Decline repair. No response has been sent.',question:'Preview selected: Ask a question. No response has been sent.',approve:'Preview selected: Accept cost & repair. No response has been sent.'};
    decisionButtons.forEach(function(button){button.addEventListener('click',function(){
      var selected=button.getAttribute('aria-pressed')==='true';
      decisionButtons.forEach(function(item){item.setAttribute('aria-pressed','false');});
      button.setAttribute('aria-pressed',String(!selected));
      if(decisionPreview){decisionPreview.textContent=selected?'Preview controls only — no response is sent from this example.':decisionMessages[button.getAttribute('data-rp-decision')];}
    });});
  }
  function boot(){document.querySelectorAll('[data-uc-repair-portal]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
